import { render, staticRenderFns } from "./quxiang.vue?vue&type=template&id=0363dd2a&"
import script from "./quxiang.vue?vue&type=script&lang=js&"
export * from "./quxiang.vue?vue&type=script&lang=js&"
import style0 from "./quxiang.vue?vue&type=style&index=0&id=0363dd2a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports